export enum AuthStorageKey {
  USER = '@gbs-auth/user',
}
